import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./motion";
import { CONTACT_EMAIL, APP_URL, PORTAL_URL } from "../../lib/siteData";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative bg-ink pt-24 md:pt-32 pb-12">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <Reveal>
          <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email-link" className="group block">
            <span className="font-body text-xs font-bold uppercase tracking-[0.25em] text-brand">Get in touch</span>
            <h2 className="mt-4 font-heading text-[13vw] md:text-[10vw] font-bold uppercase leading-[0.82] tracking-tighter text-white transition-colors duration-500 group-hover:text-brand">
              hello@sportmate.ai
            </h2>
          </a>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-16 grid grid-cols-2 gap-8 border-t border-white/10 pt-12 md:grid-cols-4">
            <div className="col-span-2 md:col-span-1">
              <img
                src="/sportmate-logo.jpg"
                alt="SportMate.ai logo"
                data-testid="footer-logo"
                className="w-44 rounded-xl border border-white/10"
              />
              <p className="mt-5 max-w-xs font-body text-sm font-light leading-relaxed text-white/50">
                Helping community sports clubs support volunteers, run better and invest in their future.
              </p>
            </div>

            <div>
              <div className="font-heading text-sm uppercase tracking-[0.2em] text-neutral-500">Explore</div>
              <ul className="mt-4 flex flex-col gap-3 font-body text-sm text-neutral-300">
                <li><a href="#pillars" className="hover:text-white transition-colors duration-300" data-testid="footer-link-pillars">How we help</a></li>
                <li><a href="#volunteer-app" className="hover:text-white transition-colors duration-300" data-testid="footer-link-app">Volunteer app</a></li>
                <li><a href="#approach" className="hover:text-white transition-colors duration-300" data-testid="footer-link-approach">Our approach</a></li>
                <li><a href="#outcomes" className="hover:text-white transition-colors duration-300" data-testid="footer-link-outcomes">Outcomes</a></li>
              </ul>
            </div>

            <div>
              <div className="font-heading text-sm uppercase tracking-[0.2em] text-neutral-500">Products</div>
              <ul className="mt-4 flex flex-col gap-3 font-body text-sm text-neutral-300">
                <li>
                  <a href={APP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 hover:text-white transition-colors duration-300" data-testid="footer-app-link">
                    Volunteer App <ArrowUpRight className="h-3.5 w-3.5" />
                  </a>
                </li>
                <li>
                  <a href={PORTAL_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 hover:text-white transition-colors duration-300" data-testid="footer-portal-link">
                    Customer Portal <ArrowUpRight className="h-3.5 w-3.5" />
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <div className="font-heading text-sm uppercase tracking-[0.2em] text-neutral-500">Talk to us</div>
              <ul className="mt-4 flex flex-col gap-3 font-body text-sm text-neutral-300">
                <li><a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-white transition-colors duration-300" data-testid="footer-contact-link">{CONTACT_EMAIL}</a></li>
                <li className="text-neutral-500">First conversation is free</li>
              </ul>
            </div>
          </div>
        </Reveal>

        <div className="mt-12 flex flex-col gap-2 border-t border-white/10 pt-6 font-body text-xs text-neutral-600 sm:flex-row sm:items-center sm:justify-between">
          <span>© {year} SportMate.ai. All rights reserved.</span>
          <span>Practical support for grassroots sport.</span>
        </div>
      </div>

      <motion.div
        aria-hidden
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
        className="mt-10 h-1 origin-left bg-brand"
      />
    </footer>
  );
};
